<template>
  <div class="">
    <page-header title="Load Consolidation" breadcrumb="Dashboard > Operations > Load Consolidation" :back="-1" />

    <div class="bg-white px-3 py-1 mt-9">
      <m-tab :tabs="tabs" :current-tab="currentTab" @current-tab="currentTab = $event" />

      <div class="topline-wrapper px-2 py-2 mb-5">
        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <CummulativeIcon />
            <p class="mt-2 font-bold">Cummulative</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">SHIPMENTS (QTY)</p>

            <p class="topline-value">{{ dispatchAnalytics && dispatchAnalytics.cumulative &&
              dispatchAnalytics.cumulative.shipmentCount }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">DISPATCHES (M)</p>

            <p class="topline-value">{{ dispatchAnalytics && dispatchAnalytics.cumulative &&
              dispatchAnalytics.cumulative.consolidationCount }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">GROSS WEIGHT(KG)</p>

            <p class="topline-value">{{ dispatchAnalytics && dispatchAnalytics.cumulative &&
              dispatchAnalytics.cumulative.grossWeight }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">Volume</p>

            <p class="topline-value">{{ dispatchAnalytics && dispatchAnalytics.cumulative &&
              dispatchAnalytics.cumulative.volume }}</p>
          </div>
        </div>

        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <TopRoutesIcon />
            <p class="mt-2 font-bold">Top Routes</p>
          </div>

          <div class="topline-child" v-for="(shippingservice, index) in (dispatchAnalytics.topRoutes || []).slice(0, 4)"
            :key="index">
            <p class="topline-header">{{ shippingservice.routeName }} (QTY)</p>
            <p class="topline-value">{{ shippingservice.shipmentCount ? shippingservice.shipmentCount : 0 }}</p>
          </div>

        </div>
      </div>

      <div class="flex items-center justify-between" style="height: 40px">
        <div class="h-full flex items-center">
          <el-dropdown>
            <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
              style="width: 40px;height: 40px;background-color: #F7FAFD;">
              <sort-icon />
            </button>
            <el-dropdown-menu slot="dropdown" placement="right-end">
              <el-dropdown-item disabled>SORT BY</el-dropdown-item>

              <el-dropdown-item>
                <button @click="sortOrder = 'ASC'" class="flex items-center">
                  <span class="ml-2">ASC</span>
                </button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="sortOrder = 'DESC'" class="flex items-center">
                  <span class="ml-2">DESC</span>
                </button>
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>

          <div class="flex items-center mr-8">
            <div class="table__search-input-wrapper">
              <span class="pr-2">
                <search-icon />
              </span>

              <input type="text" class="table__search-input" placeholder="Search..." v-model="query" />
              <div @click="showFilterModal = true" class="cursor-pointer"><search-drop-down-icon /></div>

            </div>
          </div>

          <div class="date-picker flex items-center justify-center">
            <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />

            <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
          </div>
        </div>

        <primary-button buttonText="Create New" :loading="false"
          @click="$router.push({ name: 'NewConsolidationNew' })" />
      </div>

      <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh"
        v-if="loadingConsolidations">
        <loader />
      </div>

      <div v-else-if="!(consolidations && consolidations.length)"
        class="bg-white w-100 flex justify-center flex-col items-center p-5 my-5">
        <empty-table-icon />
        <p class="font-semibold pt-3 pb-5">No Items found!</p>
      </div>

      <div v-else>
        <div class="table-wrapper" id="table-wrapper">
          <table class="custom-table responsive-table">
            <thead>
              <tr>
                <th class="width-xs">
                  <input type="checkbox" class="checkbox" />
                </th>
                <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>

                <th class="relative width-xs" tabindex="-1">
                  <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.7">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                          fill="#383F51" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                          fill="#383F51" />
                      </g>
                    </svg></span>

                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(consolidation, index) in consolidations" :key="consolidation.id" class="cursor-pointer">
                <td>
                  <input type="checkbox" />
                  <label :for="`consolidation${index}`" class="check-label"></label>
                </td>

                <td v-for="header in activeHeaders" :key="header">
                  <span v-if="header.name === 'ORIGIN'">
                    {{ consolidation.originationTerminal ? consolidation.originationTerminal.name : "N/A" }},<br />
                    {{ consolidation.originationTerminal ? consolidation.originationTerminal.state : "N/A" }}
                  </span>

                  <span v-else-if="header.name === 'DESTINATION'">
                    {{ consolidation.destinationTerminal ? consolidation.destinationTerminal.name : "N/A" }},<br />
                    {{ consolidation.destinationTerminal ? consolidation.destinationTerminal.state : "N/A" }}
                  </span>

                  <!-- Special case for Status -->
                  <span v-else-if="header.name === 'Order Status'">
                    <button :title="consolidation.status.replace(/_/g, ' ')" :class="['order_status']"
                      :style="{ ...statusColors(consolidation.status) }">
                      {{ consolidation.status.replace(/_/g, ' ').toLowerCase() }}</button>
                  </span>

                  <span v-else-if="header.name === 'Shipment Count'">
                    {{ consolidation?.shipments?.length || consolidation?.shippings?.length || 0 }}
                  </span>

                  <span v-else-if="header.name === 'Fleet Capacity'">
                    {{ consolidation.fleet ? consolidation.fleet.carriageCapacity : "N/A" }} to
                    {{ consolidation.fleet ? consolidation.fleet.currentLoadCapacity : "N/A" }}
                  </span>

                  <span v-else-if="header.name === 'Fleet + Driver'">

                    {{ consolidation?.fleet?.equipment ?? "N/A" }}

                    <span>
                      {{ consolidation &&
                        consolidation.fleet &&
                        consolidation.fleet.driver &&
                        consolidation.fleet.driver.firstname
                        ? consolidation.fleet.driver.firstname
                        :
                        "N/A" }}
                      {{ consolidation &&
                        consolidation.fleet &&
                        consolidation.fleet.driver &&
                        consolidation.fleet.driver.lastname
                        ? consolidation.fleet.driver.lastname
                        :
                        "N/A" }}
                    </span>

                    <!-- <span >
                    {{ consolidation.fleet ? consolidation.fleet.user ? consolidation.fleet.user.firstname + ' ' +
                  consolidation.fleet.user.lastname : "N.A" : "N/A" }}
                  </span> -->
                  </span>

                  <span v-else-if="header.name === 'Consolidation ID # + Date'">
                    {{ consolidation?.consolidationReference ?? "N/A" }}
                    <span class="block w-full opacity-50">{{ consolidation.createdAt ?
                      consolidation.createdAt.split("T")[0] : "N/A" }}</span>
                  </span>

                  <span v-else>
                    {{ getNestedValue(consolidation, headerMap[header.name]) }}
                  </span>
                </td>


                <td>
                  <el-dropdown v-if="currentTab == 'active'">
                    <button @click="
                      (selectedID = consolidation.id),
                      (selectedConsolidation = consolidation)
                      ">
                      <vertical-ellipsis />
                    </button>

                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="currentTab == 'active'">
                        <button class="flex items-center" @click="pushToFleetDetails(consolidation)">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M9.48558 3.51855H2.34961V4.67522H9.48558V3.51855Z" fill="#FFA600" />
                            <path
                              d="M12.982 12.2152C13.5352 11.2381 13.3748 9.99295 12.5702 9.18918C12.0942 8.71316 11.4612 8.45044 10.7858 8.45044C10.1103 8.45044 9.47648 8.71316 9.00046 9.18918C8.52444 9.6652 8.26172 10.2982 8.26172 10.9745C8.26172 11.6482 8.52444 12.282 9.00046 12.7598C9.47648 13.2341 10.1094 13.4968 10.784 13.4968C11.2236 13.4968 11.6494 13.3849 12.0274 13.1716L14.8558 16L15.8104 15.0445L12.982 12.2152ZM11.8479 12.0358C11.2826 12.6011 10.2907 12.6011 9.72533 12.0358C9.14006 11.4496 9.14006 10.4985 9.72533 9.91232C10.008 9.62965 10.386 9.47358 10.7875 9.47358C11.1889 9.47358 11.5652 9.62965 11.8488 9.91232C12.1323 10.195 12.2884 10.573 12.2884 10.9745C12.2884 11.3759 12.1314 11.7522 11.8479 12.0358Z"
                              fill="#FFA600" />
                            <path
                              d="M11.5593 14.1332H1.60971C1.4519 14.1332 1.32444 14.0049 1.32444 13.8488V1.42026C1.32444 1.26245 1.4519 1.13499 1.60971 1.13499H11.5593C11.7171 1.13499 11.8437 1.26245 11.8437 1.42026V7.76026C12.2556 7.85043 12.6397 8.02645 12.9796 8.2779V1.42026C12.9796 0.637295 12.3431 0 11.5593 0H1.60971C0.826748 0 0.189453 0.637295 0.189453 1.42026V13.8488C0.189453 14.6309 0.826748 15.2682 1.60971 15.2682H11.5593C12.1533 15.2682 12.4342 15.1277 12.6457 14.6092L12.1307 14.0942C11.9408 14.174 11.6408 14.1332 11.5593 14.1332Z"
                              fill="#FFA600" />
                            <path d="M9.48558 6.77869H2.34961V7.93536H9.48558V6.77869Z" fill="#FFA600" />
                          </svg>

                          <span class="ml-2">View Shipments</span>
                        </button>
                      </el-dropdown-item>
                      <el-dropdown-item hidden v-if="currentTab == 'active'">
                        <button v-if="!consolidation.fleetId" class="flex items-center" @click="
                          (showAssignModal = true),
                          (selectedID = consolidation.id),
                          (selectedConsolidation = consolidation)
                          ">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              d="M2.35283 13.6473C3.08592 14.3804 3.93988 14.956 4.89104 15.3584C5.87642 15.7751 6.92243 15.9864 8.00006 15.9864C9.07767 15.9864 10.1237 15.7751 11.1091 15.3584C12.0602 14.956 12.9142 14.3804 13.6473 13.6473C14.3804 12.9142 14.9561 12.0602 15.3584 11.1091C15.7751 10.1237 15.9865 9.07766 15.9865 8.00008C15.9865 6.92242 15.7751 5.8764 15.3584 4.89105C14.9561 3.93989 14.3804 3.08593 13.6473 2.35284C12.9142 1.61974 12.0603 1.04406 11.1091 0.641769C10.1237 0.22497 9.07767 0.0136719 8.00006 0.0136719C6.92243 0.0136719 5.87642 0.224997 4.89104 0.641769C3.93988 1.04406 3.08592 1.61977 2.35283 2.35284C1.61974 3.0859 1.04406 3.93989 0.641741 4.89103C0.224997 5.8764 0.0136719 6.92242 0.0136719 8.00008C0.0136719 9.07769 0.224997 10.1237 0.641768 11.1091C1.04406 12.0602 1.61977 12.9142 2.35283 13.6473ZM8.00006 1.17957C11.7669 1.17957 14.8205 4.23321 14.8205 8.00008C14.8205 11.7669 11.7669 14.8205 8.00006 14.8205C4.2332 14.8205 1.17956 11.7669 1.17956 8.00008C1.17956 4.23321 4.2332 1.17957 8.00006 1.17957Z"
                              fill="#114FF5" />
                            <circle cx="7.985" cy="7.985" r="7.985" fill="#114FF5" />
                            <path
                              d="M6.2313 10.9076C6.34062 11.0169 6.48889 11.0783 6.6435 11.0783C6.79814 11.0783 6.94638 11.0169 7.0557 10.9076L12.0465 5.91678C12.2742 5.68912 12.2742 5.32003 12.0465 5.09238C11.8189 4.86473 11.4498 4.8647 11.2221 5.09238L6.6435 9.67103L4.77639 7.80389C4.54873 7.57621 4.17964 7.57621 3.95199 7.80389C3.72434 8.03155 3.72434 8.40063 3.95199 8.62829L6.2313 10.9076Z"
                              fill="white" />
                          </svg>

                          <span class="ml-2">Assign</span>
                        </button>

                        <button v-else class="flex items-center" @click="
                          (showUnassignModal = true),
                          (selectedID = consolidation.id)
                          ">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              d="M2.35283 13.6473C3.08592 14.3804 3.93988 14.956 4.89104 15.3584C5.87642 15.7751 6.92243 15.9864 8.00006 15.9864C9.07767 15.9864 10.1237 15.7751 11.1091 15.3584C12.0602 14.956 12.9142 14.3804 13.6473 13.6473C14.3804 12.9142 14.9561 12.0602 15.3584 11.1091C15.7751 10.1237 15.9865 9.07766 15.9865 8.00008C15.9865 6.92242 15.7751 5.8764 15.3584 4.89105C14.9561 3.93989 14.3804 3.08593 13.6473 2.35284C12.9142 1.61974 12.0603 1.04406 11.1091 0.641769C10.1237 0.22497 9.07767 0.0136719 8.00006 0.0136719C6.92243 0.0136719 5.87642 0.224997 4.89104 0.641769C3.93988 1.04406 3.08592 1.61977 2.35283 2.35284C1.61974 3.0859 1.04406 3.93989 0.641741 4.89103C0.224997 5.8764 0.0136719 6.92242 0.0136719 8.00008C0.0136719 9.07769 0.224997 10.1237 0.641768 11.1091C1.04406 12.0602 1.61977 12.9142 2.35283 13.6473ZM8.00006 1.17957C11.7669 1.17957 14.8205 4.23321 14.8205 8.00008C14.8205 11.7669 11.7669 14.8205 8.00006 14.8205C4.2332 14.8205 1.17956 11.7669 1.17956 8.00008C1.17956 4.23321 4.2332 1.17957 8.00006 1.17957Z"
                              fill="#114FF5" />
                            <circle cx="7.985" cy="7.985" r="7.985" fill="#114FF5" />
                            <path
                              d="M6.2313 10.9076C6.34062 11.0169 6.48889 11.0783 6.6435 11.0783C6.79814 11.0783 6.94638 11.0169 7.0557 10.9076L12.0465 5.91678C12.2742 5.68912 12.2742 5.32003 12.0465 5.09238C11.8189 4.86473 11.4498 4.8647 11.2221 5.09238L6.6435 9.67103L4.77639 7.80389C4.54873 7.57621 4.17964 7.57621 3.95199 7.80389C3.72434 8.03155 3.72434 8.40063 3.95199 8.62829L6.2313 10.9076Z"
                              fill="white" />
                          </svg>

                          <span class="ml-2">Unassign</span>
                        </button>
                      </el-dropdown-item>

                      <el-dropdown-item
                        v-if="currentTab == 'active' && consolidation.status == 'ready_for_dispatch' && consolidation.fleetId">
                        <button class="flex items-center" @click="setDispatch(consolidation)">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_11_17319)">
                              <path
                                d="M12.6677 9.71802C11.4908 9.71802 10.5332 10.6756 10.5332 11.8525C10.5332 13.0294 11.4908 13.987 12.6677 13.987C13.8446 13.987 14.8022 13.0294 14.8022 11.8525C14.8022 10.6756 13.8446 9.71802 12.6677 9.71802ZM12.6677 12.9457C12.0648 12.9457 11.5744 12.4553 11.5744 11.8525C11.5744 11.2496 12.0648 10.7592 12.6677 10.7592C13.2705 10.7592 13.7609 11.2496 13.7609 11.8525C13.7609 12.4553 13.2705 12.9457 12.6677 12.9457Z"
                                fill="#09B78A" />
                              <path
                                d="M4.04268 9.71802C2.86579 9.71802 1.9082 10.6756 1.9082 11.8525C1.9082 13.0294 2.86575 13.987 4.04268 13.987C5.2196 13.987 6.17715 13.0294 6.17715 11.8525C6.17715 10.6756 5.2196 9.71802 4.04268 9.71802ZM4.04268 12.9457C3.43981 12.9457 2.94941 12.4553 2.94941 11.8525C2.94941 11.2496 3.43981 10.7592 4.04268 10.7592C4.64555 10.7592 5.13595 11.2496 5.13595 11.8525C5.13595 12.4553 4.64555 12.9457 4.04268 12.9457Z"
                                fill="#09B78A" />
                              <path
                                d="M9.99554 2.01306H0.520588C0.23306 2.01306 0 2.24612 0 2.53368V12.0607C0 12.3483 0.23306 12.5813 0.520588 12.5813H2.4121V11.5401H1.04118V3.05427H9.47492V11.9045H10.5161V2.53368C10.5162 2.24612 10.2831 2.01306 9.99554 2.01306Z"
                                fill="#09B78A" />
                              <path
                                d="M15.9032 7.19359L13.9768 4.50381C13.8791 4.36741 13.7215 4.28638 13.5536 4.28638H9.99609V5.32758H13.2861L14.9592 7.66406V11.3319H14.2998V12.3731H15.4798C15.7673 12.3731 16.0004 12.1402 16.0006 11.8525V7.49678C16.0006 7.38797 15.9664 7.28194 15.9032 7.19359Z"
                                fill="#09B78A" />
                              <path d="M11.0551 11.3839H5.6582V12.4251H11.0551V11.3839Z" fill="#09B78A" />
                              <path d="M15.4799 6.99353H9.99609V8.03474H15.4799V6.99353Z" fill="#09B78A" />
                              <path
                                d="M5.30967 3.62708C3.6925 3.62708 2.37695 4.94262 2.37695 6.55979C2.37695 8.17677 3.6925 9.49235 5.30967 9.49235C6.92684 9.49235 8.24238 8.1768 8.24238 6.55979C8.24238 4.94281 6.92684 3.62708 5.30967 3.62708ZM5.30967 8.45096C4.26674 8.45096 3.41816 7.60256 3.41816 6.5596C3.41816 5.51665 4.26674 4.66809 5.30967 4.66809C6.35259 4.66809 7.20118 5.51668 7.20118 6.5596C7.20121 7.60256 6.35263 8.45096 5.30967 8.45096Z"
                                fill="#09B78A" />
                              <path
                                d="M6.10766 6.10842H5.81266V5.72664C5.81266 5.43908 5.5796 5.20605 5.29207 5.20605C5.00451 5.20605 4.77148 5.43911 4.77148 5.72664V6.62901C4.77148 6.91657 5.00454 7.14959 5.29207 7.14959H6.10769C6.39525 7.14959 6.62828 6.91654 6.62828 6.62901C6.62824 6.34148 6.39518 6.10842 6.10766 6.10842Z"
                                fill="#09B78A" />
                            </g>
                            <defs>
                              <clipPath id="clip0_11_17319">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <span class="ml-2">Dispatch</span>
                        </button>
                      </el-dropdown-item>

                      <el-dropdown-item v-if="currentTab == 'active'">
                        <button class="flex items-center" @click="
                          (selectedID = consolidation.id),
                          (selectedConsolidation = consolidation),
                          (showUpdateStatusModal = true)
                          ">
                          <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
                            <path
                              d="M11.9415 3.04297L10.5315 4.45897C11.4765 5.40447 12 6.66197 12 7.99997C12 10.758 9.758 13 7 13V12L5 14L7 16V15C10.8595 15 14 11.8595 14 7.99997C14 6.12697 13.2695 4.36697 11.9415 3.04297Z"
                              fill="#10233E" />
                            <path
                              d="M9 2L7 0V1C3.1405 1 0 4.1405 0 8C0 9.873 0.7305 11.633 2.0585 12.957L3.4685 11.541C2.5235 10.5955 2 9.338 2 8C2 5.242 4.242 3 7 3V4L9 2Z"
                              fill="#10233E" />
                          </svg>

                          <span class="ml-2">Update Status</span>
                        </button>
                      </el-dropdown-item>

                      <el-dropdown-item v-if="consolidation.status !== 'on-hold' && currentTab == 'active'">
                        <button class="flex items-center" @click="putholdModal = true;
                        (selectedID = consolidation.id)">
                          <svg width="13" height="15" viewBox="0 0 13 15" fill="none">
                            <path
                              d="M11.5003 2.39995C11.1003 1.99995 10.5003 1.89995 10.0003 2.09995C10.0003 1.79995 9.90029 1.49995 9.60029 1.19995C9.40029 0.999951 9.00029 0.799951 8.50029 0.799951C8.20029 0.799951 8.00029 0.899951 7.80029 0.899951C7.80029 0.699951 7.70029 0.599951 7.60029 0.399951C7.10029 -0.200049 6.10029 -0.200049 5.60029 0.399951C5.40029 0.599951 5.20029 0.799951 5.20029 0.999951C5.00029 0.999951 4.80029 0.899951 4.60029 0.899951C4.10029 0.899951 3.80029 1.09995 3.50029 1.39995C3.00029 1.89995 3.00029 2.69995 3.00029 2.69995V6.49995C2.70029 6.19995 2.20029 5.69995 1.50029 5.69995C1.30029 5.69995 1.00029 5.79995 0.800287 5.89995C0.400287 6.09995 0.200287 6.39995 0.100287 6.79995C-0.199713 7.79995 0.700287 9.19995 0.700287 9.29995C0.800287 9.39995 1.90029 12 2.90029 13.1C3.90029 14.3 5.00029 15 7.80029 15C10.7003 15 12.0003 13.4 12.0003 9.89995V4.39995C12.0003 4.29995 12.1003 3.09995 11.5003 2.39995V2.39995ZM6.00029 1.99995C6.00029 1.69995 5.90029 0.999951 6.50029 0.999951C7.00029 0.999951 7.00029 1.49995 7.00029 1.99995V5.99995C7.00029 6.29995 7.20029 6.49995 7.50029 6.49995C7.80029 6.49995 8.00029 6.29995 8.00029 5.99995V2.19995C8.00029 2.19995 8.00029 1.79995 8.50029 1.79995C9.10029 1.79995 9.00029 2.69995 9.00029 2.69995V5.99995C9.00029 6.29995 9.20029 6.49995 9.50029 6.49995C9.80029 6.49995 10.0003 6.29995 10.0003 5.99995V3.59995C10.0003 3.49995 10.0003 2.99995 10.5003 2.99995C11.0003 2.99995 11.0003 3.99995 11.0003 3.99995V9.89995C11.0003 13.3 9.70029 14 7.80029 14C5.40029 14 4.50029 13.5 3.70029 12.4C2.80029 11.4 1.60029 8.79995 1.60029 8.69995C1.30029 8.39995 0.900287 7.49995 1.00029 7.09995C1.00029 6.99995 1.10029 6.89995 1.20029 6.79995C1.30029 6.79995 1.40029 6.69995 1.40029 6.69995C1.80029 6.69995 2.20029 7.19995 2.30029 7.39995L2.90029 8.29995C3.00029 8.49995 3.30029 8.59995 3.50029 8.49995C3.90029 8.49995 4.00029 8.29995 4.00029 8.09995V2.89995C4.00029 2.49995 4.00029 1.89995 4.50029 1.89995C4.90029 1.89995 5.00029 2.19995 5.00029 2.69995V5.99995C5.00029 6.29995 5.20029 6.49995 5.50029 6.49995C5.80029 6.49995 6.00029 6.29995 6.00029 5.99995V1.99995Z"
                              fill="#FE4D3C" />
                          </svg>

                          <span class="ml-2">Put On Hold</span>
                        </button>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="currentTab == 'active'">
                        <button class="flex items-center" @click="
                          (showConfirmCancelModal = true),
                          (selectedID = consolidation.id)
                          ">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              d="M8 15.9947C12.4183 15.9947 16 12.4154 16 8C16 3.58462 12.4183 0.00524902 8 0.00524902C3.58172 0.00524902 0 3.58462 0 8C0 12.4154 3.58172 15.9947 8 15.9947Z"
                              fill="#D72638" />
                            <path d="M10.5381 11.7741L11.7754 10.5369L5.46295 4.2244L4.2257 5.46165L10.5381 11.7741Z"
                              fill="white" />
                            <path d="M5.46295 11.7757L11.7754 5.46326L10.5381 4.22601L4.2257 10.5385L5.46295 11.7757Z"
                              fill="white" />
                          </svg>

                          <span class="ml-2">Cancel Consolidation</span>
                        </button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card modal-onHold" style="width: 500px" v-if="onHoldModal == true">
          <div class="text-center modals-wrapper px-5">
            <span @click="closeModal">X</span>
            <img src="../../../../assets/images/icons/putonhold-modal-icon.png" class=" mx-auto">
            <p class="mt-4 w-11/12 text-center">By confirming to put on-hold below, your assigned shipment would be put
              on hold. </p>
            <div class="flex flex-wrap justify-around">
              <button class="mt-12 rounded-md p-1 px-5 text-md bt-color" style="color:#10233E;"
                @click="keepOnHold(consolidationId, status)">Confirm</button>
            </div>
          </div>
        </div>

      </div>
      <pagination-control :total="totalConsolidation" :pageNumber="pageNumber" @pageNumber="setNumDisplayLocation"
        @pageSize="pageSizeFunc" />
    </div>



    <cancel-confirmation-modal :showModal="showConfirmCancelModal" itemToDelete="Consolidation"
      @close-modal="showConfirmCancelModal = false" @continue="
        (cancelReason = $event),
        (showConfirmCancelModal = false),
        (showCancelModal = true)
        " />

    <cancel-modal :showModal="showCancelModal" @close-modal="showCancelModal = false" @cancel="cancelConsolidation" />

    <FinalPutOnHoldModal :showmodal="showfinalholdmodal" :consolidationId="selectedConsolidation.id"
      @keep-hold="keepOnHold" @refetch-dispatch="$emit('   ')" @close-modal="showfinalholdmodal = false" />

    <PutOnHoldModal :showmodal="putholdModal" :consolidationId="selectedConsolidation.id"
      @refetch-dispatch="$emit('refetch-dispatch')" @show-final-hold="showfinalholdmodal = true"
      @close-modal="putholdModal = false" />


    <unassign-fleet-modal :showModal="showUnassignModal" @unassign="unassignFleet" :loading="updatingConsolidation"
      @close-modal="showUnassignModal = false" />

    <assign-fleet-modal :showModal="showAssignModal" @close-modal="showAssignModal = false" @save="assignFleet($event)"
      @refetch-consolidation="getConsolidations({ shippingStatus: currentTab, terminalId: locationId })"
      :loading="updatingConsolidation" :consolidation="selectedConsolidation" />

    <update-status-modal :consolidation="selectedConsolidation" :showmodal="showUpdateStatusModal"
      @close-modal="showUpdateStatusModal = false"
      @refetch-consolidation="getConsolidations({ shippingStatus: currentTab, terminalId: locationId })" />

    <CSF @appliedRef="appliedReference" :show-modal="showFilterModal" @close-modal="showFilterModal = false"
      :loading="loading" :consolidations="consolidations" />

    <FilterTable :show-modal="isTableFilter" @close-modal="isTableFilter = false" :activeHeaders="activeHeaders" />
    <DispatchModal :showModal="showDispatchModal" @close-modal="showDispatchModal = false"
      :consolidation="selectedConsolidation"
      @refetch-consolidation="getConsolidations({ shippingStatus: currentTab, terminalId: locationId })" />
  </div>
</template>

<script>
import moment from "moment";
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination.vue";
import MTab from "../../../UI/MTab.vue";
// import TableFilter from "./TableFilter";
import FilterTable from "../Consolidation/Modals/TableFilter.vue";
import UnassignFleetModal from "./Modals/UnassignFleet.vue";
import AssignFleetModal from "./Modals/AssignFleet.vue";
import CancelConfirmationModal from "./Modals/CancelConfirmationModal.vue";
import CancelModal from "./Modals/CancelModal.vue";
import UpdateStatusModal from "./Modals/UpdateStatusModal.vue";
import PutOnHoldModal from "./Modals/PutOnHoldModal"
import FinalPutOnHoldModal from "./Modals/FinalPutOnHoldModal"
import CummulativeIcon from "@/components/UI/svgs/CummulativeIcon.vue"
import TopRoutesIcon from "@/components/UI/svgs/TopRoutesIcon.vue"
import CSF from "../Consolidation/Modals/ConsolidationSearchFilter.vue"
import DispatchModal from "./Modals/dispatch-modal.vue"
import { orgId } from "@/services/apiConfig.js"

export default {
  components: {
    CSF,
    UpdateStatusModal,
    PageHeader,
    PaginationControl,
    // TableFilter,
    FilterTable,
    MTab,
    CancelConfirmationModal,
    CancelModal,
    UnassignFleetModal,
    AssignFleetModal,
    PutOnHoldModal,
    FinalPutOnHoldModal,
    CummulativeIcon,
    TopRoutesIcon,
    DispatchModal
  },
  data() {
    return {
      consolidationerPage: 10,
      totalConsolidation: 0,
      pageNumber: 1,
      showFilterModal: false,
      showDispatchModal: false,
      // showTableFilterModal: false,
      getId: '',
      getStatus: '',
      onHoldModal: false,
      loadingConsolidations: true,
      showUpdateStatusModal: false,
      updatingConsolidation: false,
      putholdModal: false,
      showfinalholdmodal: false,
      consolidations: [],
      isTableFilter: false,
      currentTab: "active",
      showUpdateModal: true,
      tabs: [
        { id: "active", value: "Active" },
        { id: "shipped", value: "Shipped" },
        { id: "dispatched", value: "Dispatched" },
      ],
      activeHeaders: [
        { name: "Consolidation ID # + Date" },
        { name: "Shipment Count" },
        { name: "ORIGIN" },
        { name: "DESTINATION" },
        { name: "Fleet + Driver" },
        { name: "Fleet Capacity" },
        { name: "Order Status" },
      ],
      headerMap: {
        "Consolidation ID # + Date": '',
        "Shipment Count": '',
        "ORIGIN": '',
        "DESTINATION": '',
        "Fleet + Driver": '',
        "Fleet Capacity": "",
        "Order Status": "",
        "Consolidated by:": "",
      },
      hiddenTab: { id: "shipped", value: "Shipped" },
      removedTableData: [
        "routing",
        "handOff",
        "receiveFrom",
        "deliverTo",
        "distance",
        "weight",
        "income",
        "fleet",
        "driver",
      ],
      selectedShippingServiceId: null,
      isLoading: false,
      showConfirmCancelModal: false,
      showCancelModal: false,
      showUnassignModal: false,
      showAssignModal: false,
      selectedID: "",
      selectedConsolidation: {},
      query: null,
      sortTable: false,
      startDate: null,
      endDate: null,
      cancelReason: "",
      statusArray: ["in-progress", "on-hold", "completed", "loading", "ready"],
      updating: false,
      sortOrder: "DESC",
      pageSize: 10,
      totalAmount: 0,
      dispatchAnalytics: {}
    };
  },
  mounted() {
    this.getAnalytics();
  },
  watch: {
    setparams() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query
      });
    },
    currentTab: {
      handler() {
        this.startDate = null;
        this.endDate = null;
        this.getConsolidations({ shippingStatus: this.currentTab, terminalId: this.locationId, });
      },
      immediate: true,
    },

    isTableFilter() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 500;
    },

    sortTable() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
      });

    },

    query() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize
      });
    },

    locationId() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize
      });
    },
    sortOrder() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn
      });
    },
    pageSize() {
      this.getConsolidations({
        shippingStatus: this.currentTab,
        terminalId: this.locationId,
        sortOrder: this.sortOrder,
        startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize
      });
    },

    startDate() {
      if (this.startDate && this.endDate) {
        this.getConsolidations({
          shippingStatus: this.currentTab,
          terminalId: this.locationId,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder,
          pageSize: this.pageSize
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getConsolidations({
          shippingStatus: this.currentTab,
          terminalId: this.locationId,
          sortOrder: this.sortOrder
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getConsolidations({
          shippingStatus: this.currentTab,
          terminalId: this.locationId,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getConsolidations({
          shippingStatus: this.currentTab,
          terminalId: this.locationId,
          sortOrder: this.sortOrder
        });
      }
    },
  },

  computed: {
    setparams() {
      return {
        pageSize: this.consolidationerPage,
        pageNumber: this.pageNumber,
      };
    },
    organizationId() {
      return this.$store.state.authentication.organizationId;
    },
    userid() {
      return this.$store.state.authentication.quantumUserId;
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    }
  },

  methods: {
    pageSizeFunc(val) {
      this.consolidationerPage = val;
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    setDispatch(consolidation) {
      this.showDispatchModal = true
      this.selectedConsolidation = consolidation;
    },
    statusColors(status) {
      const opac = "25";
      switch (status) {
        case "pending_loading":
          return { color: "#FFA600", backgroundColor: "#FFA60030" };
        case "loading":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "loading_complete":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "dispatched_for_delivery":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "on-hold":
          return { color: "#FFA600", backgroundColor: "#FFA60030" };
        case "ready_for_dispatch":
          return { color: "#10233E", backgroundColor: "#09B78A" + opac };
      }
    },
    getNestedValue(obj, path) {
      const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
      return value === null || value === undefined || value === '' ? 'N/A' : value;
    },

    appliedReference(filteredVal) {
      this.query = filteredVal
    },

    async getAnalytics() {
      try {
        this.loading = true;
        const response = await this.$_getConsolidationAnalytics();

        this.dispatchAnalytics = response?.data?.data

      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    viewModal(consolidationId, status) {
      this.onHoldModal = true
      this.getId = consolidationId;
      this.getStatus = status;
    },
    keepOnHold() {
      this.modifyConsolidation(this.selectedID, { status: 'on-hold' });
      this.showfinalholdmodal = false
    },
    closeModal() {
      this.onHoldModal = false
    },
    perPageSize(pageSize) {
      this.pageSize = pageSize
    },
    capitalize(str) {
      let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

      return capitalizedstr
    },
    shipsAction(id) {

      this.$store.dispatch("setShipConsolidationID", id);
      this.$router.push(`/new-booking?type=ships&consolidationId=${id}`);
    },

    async cancelConsolidation() {
      this.isLoading = true;
      const payload = {
        reason: this.cancelReason,
        orgId: orgId()
      }
      try {
        await this.$_newCancelConsolidation(this.selectedID, payload);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
        this.showCancelModal = false;

        this.getConsolidations({ shippingStatus: this.currentTab, terminalId: this?.locationId });
      }
    },

    pushToStatus(booking) {
      localStorage.setItem("booking", JSON.stringify(booking));
      this.$router.push({ name: "ConsolidationStatus" });
    },

    pushToFleetDetails(booking) {
      localStorage.setItem("fleet", JSON.stringify(booking));
      this.$router.push({
        name: "ConsolidationDetails",
        params: { id: booking.id },
      });
    },

    getCurrentLoadCap(fleet) {
      let calc = (fleet.currentLoadCapacity / fleet.carriageCapacity) * 100;
      let currentLoadCapacity = Number.parseFloat(fleet.currentLoadCapacity);
      if (calc || currentLoadCapacity) {
        return `${calc.toFixed()}% (${currentLoadCapacity.toFixed(2)})`;
      }
      return "N/A";
    },

    async getConsolidations({ shippingStatus, terminalId, startDate, endDate, sortOrder, search }) {
      this.loadingConsolidations = true;
      try {
        let response = {}

        response = await this.$_getConsolidations({
          shippingStatus,
          terminalId,
          startDate,
          endDate,
          sortOrder,
          search,
          pageSize: this.consolidationerPage,
          pageNumber: this.pageNumber
        });

        this.consolidations = response?.data?.data?.consolidation ?? "N/A";
        this.totalAmount = response?.data?.data?.consolidationTotalValue;
        this.totalConsolidation = response?.data?.data?.totalCount;

        this.$store.dispatch("setConsolidations", response.data.data.consolidations);



      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingConsolidations = false;
      }
    },

    unassignFleet() {
      this.modifyConsolidation(this.selectedID, {
        fleetId: null,
        documentUrl: null,
        vehicleType: null,
        destination: null,
      });
    },

    assignFleet(payload) {
      this.modifyConsolidation(this.selectedID, payload);
    },

    async modifyConsolidation(consolidationId, payload) {
      try {
        this.updatingConsolidation = true;
        await this.$_modifyConsolidation(consolidationId, payload);

        this.generateToast("Successfully updated consolidation", "success");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.updatingConsolidation = false;
        this.showUnassignModal = false;
        this.showAssignModal = false;
        this.showUpdateStatusModal = false;

        this.getConsolidations({ shippingStatus: this.currentTab, terminalId: this?.locationId });
      }
    },

    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);

      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }

      this.isTableFilter = false;
      this.scrollLeft();
    },

    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 10000;
    },

    returnPackageDescription(packageItems) {
      const packageDescriptions = [];
      packageItems.forEach((item) => {
        packageDescriptions.push(item.description);
      });
      return packageDescriptions.join(", ");
    },

    returnItemsWeights(packageItems) {
      const packageWeights = [];
      packageItems.forEach((item) => {
        if (item.weight) {
          packageWeights.push(item.weight);
        }
      });
      return packageWeights.join(", ") ? packageWeights.join(", ") : "N/A";
    },

    returnHandlingRequirements(packageItems) {
      const handlingRequirements = [];
      packageItems.forEach((item) => {
        const itemHandlingRequirements = item.specialHandling.join(", ");
        handlingRequirements.push(itemHandlingRequirements);
      });
      return handlingRequirements.join(", ")
        ? handlingRequirements.join(", ")
        : "N/A";
    },
  },
};
</script>

<style lang="scss" scoped>
.order_status {
  @apply text-xs w-[120px] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-3
}

.topline-wrapper {
  border: 1px solid gray;
  border-style: dashed;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 10px;
  background-color: white;
  box-sizing: content-box;
  box-shadow: 10px 10px 30px rgb(227, 224, 224);

  .topline {
    background-color: #F2F7FC;
    border-radius: 10px;
    margin-top: 7px;
    min-height: 72px;
    padding-top: 16px;
    padding-bottom: 16px;
    vertical-align: middle;

    .topline-child {
      border-right: 1px dashed #4142455C;
      min-height: 40px;
      padding: 0px 20px 10px 20px;
      width: 20%;

      .topline-header {
        color: #7A90A7;
        font-weight: 600;
        font-size: 14px;
      }

      .topline-value {
        color: #10233E;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}


#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}

.booking-categories {
  display: flex;
}

.booking-category {
  color: #383f51;
  opacity: 0.7;
  display: flex;
  align-items: center;
  margin-right: 1rem;

  &.active {
    font-weight: 500;
    opacity: 1;

    .booking-category-amount {
      background: #10233e;
    }
  }

  .booking-category-amount {
    background: #8a97a5;
    border-radius: 10px;
    color: #ffffff;
    margin-left: 1rem;
    padding: 0.25rem 0.75rem;
  }
}

.booking-categories {
  display: flex;
  align-items: center;
  margin: 2rem 0 4rem 0;
}

th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
}

.width-md {
  min-width: 5rem;
}

.width-sm {
  min-width: 8rem;
}

.width-xs {
  min-width: 3rem !important;
}



td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

}

.shipping-option-col {
  width: 16%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  border-radius: 8px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;

  &.cancelled {
    background: #fae5e7;
    color: #d72638 !important;
  }

  &.pending {
    background: #ebfffa;
    color: #09b78a;
  }
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
  border: 1px solid #dae8f6;
  border-radius: 5px;
  height: 40px;
}

.financial-summary {
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 5px;

  .header {
    padding: 0.5rem 2rem;
  }

  width: 25rem;
}

.total-income {
  padding: 1rem 2rem;
}

.gross-income {
  background: var(--primaryblue);
  color: #ffffff;
  padding: 1rem 2rem;
}

.filter {
  background: #f7fafd;
  border-radius: 5px;
  padding: 0.75rem 1rem;
}

.card {
  padding: 2rem 2rem;
}

.input {
  margin-bottom: 1.5rem;
}

.label {
  color: #383f51;
  font-size: 0.9rem;
  font-weight: 600;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  padding: 0.75rem;
  z-index: 9999;
  font-size: 0.9rem;
  width: 15rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}

.sort-button {
  background: #f7fafd;
  /* Cards/Shadow-Small */

  box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06), 0px 1px 3px rgba(8, 7, 8, 0.1);
  border-radius: 5px;

  &:hover {
    box-shadow: unset;
  }
}

.table-date-filter {
  width: 207px;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  border-radius: 4px;
}

.modal-onHold {
  position: absolute;
  top: 500px;
  z-index: 100;
  left: 550px;
  padding: 30px;

  span {
    color: red;
    float: right;
    cursor: pointer;
  }
}

.bt-color {
  background-color: orange;
}
</style>
